import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import * as React from "react";

import { fontFamilies, layoutTokens, semanticColors as colors } from "@/designTokens";

type BadgeStatus = "new" | "success" | "error" | "warning" | "info" | "neutral";
interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: BadgeStatus;
  label: string;
}
const useStyles = makeStyles({
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 20,
    padding: "0 8px",
    borderRadius: layoutTokens.radius.sm,
    fontFamily: fontFamilies.body,
    fontSize: 10,
    fontWeight: 500,
    lineHeight: 1,
    whiteSpace: "nowrap",
  },
  new: { backgroundColor: colors["accent/bg"], color: colors["accent/text"] },
  success: { backgroundColor: colors["status/success-bg"], color: colors["status/success-text"] },
  error: { backgroundColor: colors["status/error-bg"], color: colors["status/error"] },
  warning: { backgroundColor: colors["status/warning-bg"], color: colors["text/primary"] },
  info: { backgroundColor: colors["status/info-bg"], color: colors["action/primary-hover"] },
  neutral: { backgroundColor: colors["surface/subtle"], color: colors["text/secondary"] },
});
export const StatusBadge: React.FC<StatusBadgeProps> = ({ status = "neutral", label, className, ...props }) => {
  const classes = useStyles();
  return (
    <span {...props} className={clsx(classes.root, classes[status], className)}>
      {label}
    </span>
  );
};
